import {
  PHOTO_TYPE_FACE, PHOTO_TYPE_TONGUE, RESET_WKWEBVIEW_PREVIEW_PHOTO,
  SET_WKWEBVIEW_PREVIEW_PHOTO,
} from '../actions/wkwebview';

const wkwebviewphotoInitialState = {
  wkwebviewPhoto: {
    [PHOTO_TYPE_FACE]: null,
    [PHOTO_TYPE_TONGUE]: null,
  },
};

const wkwebviewPhoto = (previousState, action) => {
  let state = { ...previousState };
  switch (action.type) {
    case SET_WKWEBVIEW_PREVIEW_PHOTO:
      state[action.photoType] = action.src;
      break;
    case RESET_WKWEBVIEW_PREVIEW_PHOTO:
      state = { ...wkwebviewphotoInitialState.wkwebviewPhoto };
      break;
    default:
      break;
  }
  return state;
};

export { wkwebviewphotoInitialState, wkwebviewPhoto };



// WEBPACK FOOTER //
// ./src/reducers/wkwebview.js